import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8e80b258"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "w-100 card verify-card",
  style: {"max-width":"880px","margin":"auto"}
}
const _hoisted_2 = {
  key: 0,
  class: "card-body"
}
const _hoisted_3 = { class: "pb-3" }
const _hoisted_4 = { class: "fw-bold d-flex align-items-center text-dark" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_6 = { class: "fv-row mb-10 ms-3 answerText" }
const _hoisted_7 = {
  key: 0,
  class: "pt-11"
}
const _hoisted_8 = { class: "fw-bold d-flex align-items-center text-dark ms-3" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "mt-9 mb-9" }, null, -1))
const _hoisted_10 = { class: "questionTitle mb-7" }
const _hoisted_11 = { class: "form-check form-check-custom form-check-solid mx-md-5 me-5" }

import { inject, onMounted, ref, watch } from "vue";
import {
  financialSelections,
  positionSelections,
} from "@/core/data/verification/auFinancialSelections";
import financialTest from "@/core/data/verification/auFinancialQuestions";
import financialTestAns from "@/core/data/verification/auFinancialAnswer";
import { getLanguage } from "@/core/types/LanguageTypes";

import { useI18n } from "vue-i18n";
import { Field } from "vee-validate";
import VerificationService from "@/projects/client/modules/verification/services/VerificationService";
import MsgPrompt from "@/core/plugins/MsgPrompt";
import { Actions } from "@/store/enums/StoreEnums";
import { useStore } from "@/store";
import { useRouter } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'UserAuFinancial',
  props: {
    verificationDetails: {}
  },
  setup(__props: any) {

const props = __props;

const { t } = useI18n();
const store = useStore();
const router = useRouter();
const isLoading = ref(true);
const formData = ref({});
const questions = ref<any>({});



onMounted(() => {
  questions.value = structuredClone(financialTest[getLanguage.value]);
  formData.value = props.verificationDetails?.financial;

  Object.keys(questions.value).forEach((key) => {
    if (formData.value && formData.value[`q${key}`]) {
      questions.value[key].answer = formData.value[`q${key}`];
    } else {
      questions.value[key].answer = [];
    }
  });

  isLoading.value = false;
});

watch(
  () => props.verificationDetails,
  () => {
    formData.value = {
      ...props.verificationDetails?.financial,
    };
  }
);

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!isLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.$t("title.financial")), 1)
          ]),
          _hoisted_5,
          _createVNode(_component_el_form_item, {
            label: _ctx.$t('fields.industry'),
            prop: "industry",
            class: "mb-5"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: formData.value.industry,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.industry) = $event)),
                name: "industry",
                size: "large"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(financialSelections), (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      label: item.label,
                      value: item.value,
                      key: item.value
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_form_item, {
            label: _ctx.$t('fields.position'),
            prop: "position",
            class: "mb-5"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_radio_group, {
                modelValue: formData.value.position,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.position) = $event)),
                name: "position",
                class: "row gap-6 w-100",
                style: {"margin-left":"0.1rem"}
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(positionSelections), (item) => {
                    return (_openBlock(), _createBlock(_component_el_radio, {
                      key: item.value,
                      label: item.value,
                      class: "col",
                      border: ""
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.label), 1)
                      ]),
                      _: 2
                    }, 1032, ["label"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createElementVNode("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(questions.value, (item, index) => {
              return (_openBlock(), _createElementBlock("div", { key: index }, [
                (index == 9)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createElementVNode("h2", _hoisted_8, _toDisplayString(_ctx.$t("title.relevantTradingExperience")), 1)
                    ]))
                  : _createCommentVNode("", true),
                _hoisted_9,
                _createElementVNode("div", _hoisted_10, " ( " + _toDisplayString(index) + " ) " + _toDisplayString(item.question), 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.options, (option, val, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "d-flex mt-3",
                    key: index
                  }, [
                    _createElementVNode("div", _hoisted_11, [
                      _createVNode(_unref(Field), {
                        modelValue: item.answer,
                        "onUpdate:modelValue": ($event: any) => ((item.answer) = $event),
                        class: "form-check-input",
                        type: "checkbox",
                        name: item.id.toString(),
                        value: val
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "name", "value"])
                    ]),
                    _createElementVNode("div", null, _toDisplayString(option), 1)
                  ]))
                }), 128))
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})